import Glide from "@glidejs/glide"

document.addEventListener("turbolinks:load", () => {
  if (document.querySelectorAll('.glide').length > 0) {
    new Glide('.glide', { type: 'carousel' }).mount();
  }
});
